import { render, staticRenderFns } from "./dashboard_rewards_history.html?vue&type=template&id=1d799341&scoped=true&"
import script from "./dashboard_rewards_history.js?vue&type=script&lang=js&"
export * from "./dashboard_rewards_history.js?vue&type=script&lang=js&"
import style0 from "./dashboard_rewards_history.scss?vue&type=style&index=0&id=1d799341&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d799341",
  null
  
)

export default component.exports